import { useHotkeys } from 'react-hotkeys-hook';
import { useSidebarCollapse } from '../layout/sidebar-collapse-context';

/**
 * Registers Cmd/Ctrl+B to toggle the sidebar — the same chord
 * shadcn/VS Code/Linear/Notion use. Reads `toggle` from the layout's
 * `SidebarCollapseProvider`, so this component must be mounted inside it.
 * Enabled in form fields too: Cmd+B doesn't do anything useful in plain
 * inputs, and a global nav shortcut should be reachable mid-typing.
 */
export function SidebarToggleHotkey() {
  const { toggle } = useSidebarCollapse();
  useHotkeys(
    'mod+b',
    (event) => {
      event.preventDefault();
      toggle();
    },
    {
      description: 'Toggle sidebar',
      metadata: { group: 'General' },
      enableOnFormTags: ['INPUT', 'TEXTAREA', 'SELECT'],
      enableOnContentEditable: true,
    },
    [toggle],
  );
  return null;
}
